export default __webpack_public_path__ + "static/media/SHADE.b37c667d.png";